// extracted by mini-css-extract-plugin
module.exports = {"root":"UnpaidInvoicesPage_root__19bEe","loading":"UnpaidInvoicesPage_loading__2WTiL"};